<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h4 class="f-sb my-0">Manage Products</h4>
					<b-breadcrumb :items="breadcrumb"></b-breadcrumb>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Product</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" class="text-left" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
                                    <template v-slot:cell(image)="row">
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" src="../assets/icons/blank.svg">{{row}}</b-img>
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/products/'+row.item.product_id+'/'+row.value">{{row}}</b-img>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm"><!--<b-icon class="mr-2" icon="pencil" aria-hidden="true"></b-icon>-->Quick Edit</b-button>
										<b-button pill class="mr-1" :href="'/dyo/product/'+row.item.product_id+'/edit'" size="sm"> Edit</b-button>
										<b-button pill class="mr-1" @click="showDeleteModal(row.item)" size="sm">Delete</b-button>
										<b-button pill class="mr-1" v-if="row.item.glbfile!='' && row.item.total_artworks>0" @click="openUrl($root.APPURL+'#/preview/'+row.item.product_id)" size="sm">Preview</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Product':'Add Product'" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">

				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
						<b-row class="mb-1">
							<b-col cols="4">
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Product Title</label></b-col>
									<b-col><b-form-input v-model="selectedItem.title" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Product Category</label></b-col>
									<b-col><b-form-input v-model="selectedItem.category" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">URL Slug</label></b-col>
									<b-col><b-form-input v-model="selectedItem.url_slug" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Product Image</label></b-col>
									<b-col>
										<b-form-file type="file" v-model="product_inf.product_image" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
										<b-form-text id="password-help-block">{{selectedItem.image}}</b-form-text>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Model File</label></b-col>
									<b-col>
										<b-form-file type="file" v-model="product_inf.product_glb" accept=".glb" size="sm" placeholder="Choose a Model file"></b-form-file>
										<b-form-text id="password-help-block">{{selectedItem.glbfile}}</b-form-text>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Cart Price</label></b-col>
									<b-col><b-form-input v-model="selectedItem.price" required size="sm" placeholder="eq. 19.99"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Minimum Qty</label></b-col>
									<b-col><b-form-input v-model="selectedItem.product_data.min_qty" required size="sm" placeholder="eq. 5"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Weight</label></b-col>
									<b-col><b-form-input v-model="selectedItem.product_data.weight" required size="sm" placeholder="eq. 1.2"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Status</label></b-col>
									<b-col><b-form-select v-model="selectedItem.status" :options="$root.status_options" required size="sm"></b-form-select></b-col>
								</b-row>
							</b-col>
							<b-col cols="4">
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Front View</label></b-col>
									<b-col><b-form-input v-model="selectedItem.model_data.front_view" required size="sm" placeholder="eq. Front"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Back View</label></b-col>
									<b-col><b-form-input v-model="selectedItem.model_data.back_view" required size="sm" placeholder="eq. Back"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Position Offset </label></b-col>
									<b-col class="flex-row"><span class="font-md pt-1 pr-1">X:</span><b-form-input v-model="selectedItem.model_data.offset_x" required size="sm"></b-form-input></b-col>
									<b-col class="flex-row"><span class="font-md pt-1 pr-1">Y:</span><b-form-input v-model="selectedItem.model_data.offset_y" required size="sm"></b-form-input></b-col>
									<b-col class="flex-row"><span class="font-md pt-1 pr-1">Z:</span><b-form-input v-model="selectedItem.model_data.offset_z" required size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="text-right font-sm">Scale</label></b-col>
									<b-col><b-form-input v-model="selectedItem.model_data.scale" required size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="text-right font-sm">Light Intensity</label></b-col>
									<b-col><b-form-input v-model="selectedItem.model_data.light" required size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="text-right font-sm">SVG Dimensions</label></b-col>
									<b-col><b-form-input v-model="selectedItem.model_data.svg_width" required size="sm"></b-form-input></b-col>
									<b-col cols="1" class="text-center"><label class="font-sm">X</label></b-col>
									<b-col><b-form-input v-model="selectedItem.model_data.svg_height" required size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="text-right font-sm">Front Area</label></b-col>
									<b-col class="pr-1"><b-form-input v-model="selectedItem.model_data.front_x" placeholder="0" required size="sm"></b-form-input></b-col>
									<b-col class="pl-1 pr-1"><b-form-input v-model="selectedItem.model_data.front_y" placeholder="0" required size="sm"></b-form-input></b-col>
									<b-col class="pl-1 pr-1"><b-form-input v-model="selectedItem.model_data.front_width" placeholder="0" required size="sm"></b-form-input></b-col>
									<b-col class="pl-1"><b-form-input v-model="selectedItem.model_data.front_height" placeholder="0" required size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="text-right font-sm">Back Area</label></b-col>
									<b-col class="pr-1"><b-form-input v-model="selectedItem.model_data.back_x" placeholder="0" required size="sm"></b-form-input></b-col>
									<b-col class="pl-1 pr-1"><b-form-input v-model="selectedItem.model_data.back_y" placeholder="0" required size="sm"></b-form-input></b-col>
									<b-col class="pl-1 pr-1"><b-form-input v-model="selectedItem.model_data.back_width" placeholder="0" required size="sm"></b-form-input></b-col>
									<b-col class="pl-1"><b-form-input v-model="selectedItem.model_data.back_height" placeholder="0" required size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Enable NameNumber</label></b-col>
									<b-col>
										<b-form-select v-model="selectedItem.model_data.enable_namenumber" required size="sm">
											<b-form-select-option value="yes">Yes</b-form-select-option>
											<b-form-select-option value="no">No</b-form-select-option>
										</b-form-select>
									</b-col>
								</b-row>
							</b-col>
							
							<b-col cols="4">
								<b-row class="mb-3">
									<b-col><div class="alert alert-warning heading mb-0" role="alert" size="sm">Advanced Effects</div>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Normal Map</label></b-col>
									<b-col>
										<b-form-file type="file" v-model="model_maps.map_normal" accept=".jpeg, .jpg, .png" size="sm" placeholder="Choose a Normal Map"></b-form-file>
										<b-form-text id="password-help-block">{{selectedItem.map_data.map_normal}}</b-form-text>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">AO Map</label></b-col>
									<b-col>
										<b-form-file type="file" v-model="model_maps.map_ao" accept=".jpeg, .jpg, .png" size="sm" placeholder="Choose a AO Map"></b-form-file>
										<b-form-text id="password-help-block">{{selectedItem.map_data.map_ao}}</b-form-text>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Light Map</label></b-col>
									<b-col>
										<b-form-file type="file" v-model="model_maps.map_light" accept=".jpeg, .jpg, .png" size="sm" placeholder="Choose a Light Map"></b-form-file>
										<b-form-text id="password-help-block">{{selectedItem.map_data.map_light}}</b-form-text>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Bump Map</label></b-col>
									<b-col>
										<b-form-file type="file" v-model="model_maps.map_bump" accept=".jpeg, .jpg, .png" size="sm" placeholder="Choose a Bump Map"></b-form-file>
										<b-form-text id="password-help-block">{{selectedItem.map_data.map_bump}}</b-form-text>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-container>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'product-record',
			insertUrl: this.$root.WEBAPI+'product-insert',
			updateUrl: this.$root.WEBAPI+'product-update',
			deleteUrl: this.$root.WEBAPI+'product-delete',
			csvgenUrl: this.$root.WEBAPI+'product-csvgen',
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'category', label: 'category' },
				{ key: 'url_slug', label: 'URL Slug' },
				{ key: 'image', label: 'Image' },
                { key: 'price', label: 'Price' },
                { key: 'position', label: 'Position' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {product_data:{},model_data:{}, map_data:{}},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				url_slug: '',
				category: '',
				price: 0.00,
				product_data:{},
				model_data:{}, 
				map_data:{},
                status: 0
			}
		};
	},
	methods: {
		openUrl(url){
			window.open(url, "_blank");
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.product_data){
				this.selectedItem.product_data = JSON.parse(item.product_data);
			}
			if(item.model_data){
				this.selectedItem.model_data = JSON.parse(item.model_data);
			}
			if(item.map_data){
				this.selectedItem.map_data = JSON.parse(item.map_data);
			}
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showCsvModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: item.product_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){

							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete product!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.product_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
            }

            let formData = new FormData();
            formData.append('imagefile', this.product_inf.product_image);
			formData.append('glbfile', this.product_inf.product_glb);
			formData.append('mapfile_normal', this.model_maps.map_normal);
			formData.append('mapfile_ao', this.model_maps.map_ao);
			formData.append('mapfile_light', this.model_maps.map_light);
			formData.append('mapfile_bump', this.model_maps.map_bump);
            formData.append('data', JSON.stringify(this.selectedItem));
            formData.append('accesskey', this.$session.get('access_key'));

            /*var req = new XMLHttpRequest()
            req.open("POST", submitUrl);
            req.onload = function(event) {
                alert(event.target.responseText)
            }
            req.send(formData);*/
            
			self.axios.post(submitUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					self.loading = false;
					self.totalRows = self.records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
</style>